module.exports = __webpack_public_path__ + "img/Icon - skipped-stats.fc96eafb.svg";